// Dashboard Users activity page translations (en-US), loaded into dashboard.users.activity by ../en-US.users.js
module.exports = {
  menu: "Activity",
  title: "User Activity",
  description: "DAU, WAU, MAU, sessions, returning and inactive users.",
  kpis: {
    dau: "DAU (period average)",
    wau: "WAU (7 days)",
    mau: "MAU (30 days)",
    stickiness: "Stickiness DAU / MAU",
    sessions: "Sessions",
    avgSession: "Average session time",
    retention30: "30-day retention",
    inactive: "Inactive users (30+ days)",
  },
  info: {
    dau: "Average unique users per day in the period (daily active users).\nSource: Google Analytics (without it, Firebase: activity log sent by the apps).",
    wau: "Unique users in the 7 days up to the end of the period (weekly active users).\nSource: Google Analytics (without it, Firebase: activity log sent by the apps).",
    mau: "Unique users in the 30 days up to the end of the period (monthly active users).\nSource: Google Analytics (without it, Firebase: activity log sent by the apps).",
    stickiness: "Share of the monthly users who use the app on a typical day (DAU ÷ MAU); the higher, the more frequent the use.\nSource: Google Analytics (without it, Firebase: activity log sent by the apps).",
    sessions: "Times the app was opened in the period.\nSource: Google Analytics (without it, Firebase: activity log sent by the apps).",
    avgSession: "Average length of each app session in the period.\nSource: Google Analytics (without it, Firebase: activity log sent by the apps).",
    retention30: "Users who first used the app in the period and came back 30 days later.\nSource: Google Analytics (without it, Firebase: activity log sent by the apps).",
    inactive: "Registered users who did not use the app in the 30 days up to the end of the period (registered total minus the MAU).\nSource: Firebase (profile index) and Google Analytics (without it, Firebase: activity log sent by the apps).",
  },
  hints: {
    shorterThan7: "period shorter than 7 days",
    shorterThan30: "period shorter than 30 days",
    needsMau: "needs the MAU (period ≥ 30 days)",
    cohortsAverage: "average of the cohorts",
    cohortsRange: "cohorts from {start} to {end}",
    noOldAccounts: "no account in the period is 30 days old",
  },
  modals: {
    dau: {
      title: "DAU",
    },
    sessions: {
      title: "Sessions",
    },
  },
  series: {
    dau: "DAU",
    wau: "WAU",
    mau: "MAU",
  },
  panels: {
    evolution: "DAU, WAU and MAU by {gran}",
    split: "New, returning and inactive",
    weekday: "Sessions per weekday",
    funnel: "Activity funnel",
  },
  split: {
    recurring: "Returning",
    new: "New",
    inactive: "Inactive (30+ days)",
    users: "users",
  },
  weekdays: {
    mon: "Monday",
    tue: "Tuesday",
    wed: "Wednesday",
    thu: "Thursday",
    fri: "Friday",
    sat: "Saturday",
    sun: "Sunday",
  },
  weekdaysShort: {
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
    sun: "Sun",
  },
  funnel: {
    registered: "Registered",
    active30: "Active 30 days",
    active7: "Active 7 days",
    activeLast: "Active on {date}",
  },
  panelInfo: {
    evolution: "Active users per day (DAU), in 7 days (WAU) and in 30 days (MAU) up to the end of each interval.\nSource: Google Analytics (without it, Firebase: activity log sent by the apps).",
    split: "New and returning active users of the period and the registered ones with no use for 30 days or more.\nSource: Google Analytics (without it, Firebase: activity log sent by the apps) and Firebase (profile index).",
    weekday: "Sessions on each weekday in the period.\nSource: Google Analytics (without it, Firebase: activity log sent by the apps).",
    funnel: "Registered users, active in the 30 and 7 days up to the end of the period and active on its last day.\nSource: Firebase (profile index) and Google Analytics (without it, Firebase: activity log sent by the apps).",
  },
};
